// extracted by mini-css-extract-plugin
module.exports = {"side-menu":"side-menu-1yx2u","menu-text":"menu-text-1MNDl"};